class MediaEmbedPopup {
  constructor() {}

  setup() {
    if(typeof generateIframeTag === "function") return; // If old not removed

    const cls = this;
    document.querySelector(".build-embed-function-link").addEventListener("click", function(e) {
      e.preventDefault();

      const parentWrapper = this.closest(".vrtx-media-button-holder");

      var embedBox = parentWrapper.querySelector(".embed-video-box");
      if (embedBox.style.display === "block") {
        embedBox.style.display = "none";
        return;
      }

      const widthInputField = embedBox.querySelectorAll(".vrtx-media-dimensions-input-field")[0];
      const heightInputField = embedBox.querySelectorAll(".vrtx-media-dimensions-input-field")[1];
      const embedIframe = embedBox.querySelector(".customIframe");

      const height = heightInputField.dataset.height.replace(/\s+/g, '');
      const width = widthInputField.dataset.width.replace(/\s+/g, '');
      const requestURL = embedIframe.dataset.url;
      const aspectRatio = (width/height);
      let lastWidth = width;
      const iFrameTag = cls.generateIframeTag(requestURL, height, width);

      //Setting default values
      embedIframe.value  = iFrameTag;
      widthInputField.value = width;
      heightInputField.value = height;
      embedBox.style.display = "block";
      embedIframe.select();

      //Attaching events
      embedIframe.addEventListener("click", function(e) {
        this.select();
      });

      widthInputField.addEventListener("change", function() {
        const newWidth = parseInt(widthInputField.value, 10);
        if (!isNaN(newWidth)) {
          const newHeight = (newWidth / aspectRatio).toFixed();
          heightInputField.value = newHeight;
          const newIframeTag = cls.generateIframeTag(requestURL, newHeight, newWidth);
          embedIframe.value = newIframeTag;
          lastWidth = newWidth;
        }

        if (widthInputField.value == "") {
          lastWidth = "";
          return;
        } else { // The user input is invalid, setting width to last value
          widthInputField.value = lastWidth;
        }
      });
    });

    // Close on click outside or Escape key
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".embed-video-box, .build-embed-function-link")) {
        document.querySelector(".embed-video-box").style.display = "none";
      }
    });
    document.addEventListener("keydown", (e) => {
      if(e.key == "Escape") {
        document.querySelector(".embed-video-box").style.display = "none";
      }
    });
  }

  generateIframeTag(srcURL, height, width) {
    const url = srcURL + "?vrtx=video-embed";
    return '';
  }
}
export default new MediaEmbedPopup;